import { render, staticRenderFns } from "./AdminContentEditor.vue?vue&type=template&id=49f3f2dc&"
import script from "./AdminContentEditor.vue?vue&type=script&lang=ts&"
export * from "./AdminContentEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports